import axios from "axios";
import { DataGrid, Popup } from "devextreme-react";
import { Column, Lookup, MasterDetail } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";
import { paymentItem } from "../data";

export default function AuditTrails(props) {
  const {
    auditTrailsPopupVisible,
    setAuditTrailsPopupVisible,
    contractBasicInfo,
  } = props;

  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    if (contractBasicInfo.contrNo) {
      setDataSource(
        new CustomStore({
          key: ["employeeNo", "date"],
          load: async () => {
            // [R28]
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/AT/${contractBasicInfo.contrNo}/${contractBasicInfo.SEQ}`
            );

            return getATData(result.data);
          },
        })
      );
    }
  }, [contractBasicInfo.contrNo]);

  const getATData = (data) => {
    const atData = data.reduce(
      (acc, { employeeNo, name, date, item, oldValue, newValue }) => {
        if (acc[employeeNo + date]) {
          acc[employeeNo + date].modifiedData.push({
            item,
            oldValue,
            newValue,
          });
        } else {
          acc[employeeNo + date] = {
            employeeNo,
            name,
            date,
            modifiedData: [{ item, oldValue, newValue }],
          };
        }

        return acc;
      },
      []
    );

    return Object.values(atData);
  };

  const onHiding = () => {
    setAuditTrailsPopupVisible(false);
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.texstAlign = "center";
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.backgroundColor = "#E2EFDA";
    }
  };

  const render = (e) => {
    return (
      <>
        <h3>Details</h3>
        <DataGrid
          allowColumnResizing={true}
          columnResizingMode="nextColumn"
          dataSource={e.data.modifiedData}
          showBorders={true}
          showColumnLines={true}
          wordWrapEnabled={true}
          onCellPrepared={onCellPrepared}
        >
          <Column
            dataField={"item"}
            alignment={"center"}
            caption={"Item"}
            width={200}
          >
            <Lookup
              dataSource={paymentItem}
              displayExpr={"name"}
              valueExpr={"id"}
            />
          </Column>
          <Column
            dataField={"oldValue"}
            alignment={"center"}
            caption={"Old Value"}
          />
          <Column
            dataField={"newValue"}
            alignment={"center"}
            caption={"New Value"}
          />
        </DataGrid>
      </>
    );
  };

  return (
    <Popup
      visible={auditTrailsPopupVisible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="Audit Trails"
      height={"550"}
      width={"auto"}
      onHiding={onHiding}
    >
      <DataGrid
        dataSource={dataSource}
        allowColumnResizing={true}
        columnResizingMode="nextColumn"
        height={"100%"}
        showBorders={true}
        showColumnLines={true}
        width={"700"}
        wordWrapEnabled={true}
        style={{
          maxHeight: "calc(100vh - 145px)",
        }}
      >
        <Column dataField={"name"} alignment={"center"} caption={"Editor"} />
        <Column
          dataField={"employeeNo"}
          alignment={"center"}
          caption={"Employee No."}
        />
        <Column
          dataField={"date"}
          alignment={"center"}
          caption={"Modified Date"}
          dataType={"date"}
          format="yyyy-MM-dd"
        />
        <MasterDetail enabled={true} render={render} />
      </DataGrid>
    </Popup>
  );
}
